import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router'
import { useEffect } from 'react'
import { logger } from '../../ui'

export function RouteErrorComponent({ error, ...rest }: ErrorComponentProps) {
	useEffect(() => {
		logger.error(error, {
			category: 'router',
			tags: { source: 'route-error-boundary' },
		})
	}, [error])

	return <ErrorComponent error={error} {...rest} />
}
